module.exports = __webpack_public_path__ + "static/media/cIQoMs9TlcRAY9k6FT985CZm60HAQbVPvMs3pwos.6da9c3c3.webp";